// extracted by mini-css-extract-plugin
export default {"headcontainer":"support_headcontainer__G0+wm","hr":"support_hr__bC9Do","card":"support_card__1m8Wi"};